module.exports = __webpack_public_path__ + "img/client (1).5fa218de.jpg";